module.exports = __webpack_public_path__ + "media/lesson/images/assessment/preloader-c53ebd7b81350d6a2bdbc393ebb3e30e.gif";